import React, { useEffect, useState } from 'react';
import "../styles/cookieConsent.css";

const COOKIE_KEY = "cookieConsent";
const COOKIE_VERSION = "v1"; // később ha változik, pl. v2

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_KEY);
        if (!consent || consent !== COOKIE_VERSION && consent !== "rejected") {
            setVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem(COOKIE_KEY, COOKIE_VERSION);
        setVisible(false);
    };

    const rejectCookies = () => {
        localStorage.setItem(COOKIE_KEY, "rejected");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-overlay">
            <div className="cookie-card">
                <h4>🍪 Sütik használata</h4>

                <p>
                    A focifanatik.hu sütiket használ a jobb felhasználói élmény érdekében.
                    Ezek segítenek az oldal működésében és fejlesztésében.
                </p>

                <div className="cookie-actions">
                    <button className="cookie-reject" onClick={rejectCookies}>
                        Nem fogadom el
                    </button>
                    <button className="cookie-accept" onClick={acceptCookies}>
                        Elfogadom
                    </button>
                </div>
            </div>
        </div>
    )
}
